import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "23",
  viewBox: "0 0 22 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_7688_19748)" }, [
      _createElementVNode("path", {
        d: "M15.9318 12.7952L16.5379 8.84377H12.7466V6.27952C12.7466 5.19847 13.2762 4.14475 14.9743 4.14475H16.6981V0.78068C16.6981 0.78068 15.1337 0.513672 13.6381 0.513672C10.5156 0.513672 8.47479 2.4061 8.47479 5.83213V8.84377H5.00391V12.7952H8.47479V22.3476C9.17076 22.4568 9.88408 22.5137 10.6107 22.5137C11.3374 22.5137 12.0507 22.4568 12.7466 22.3476V12.7952H15.9318Z",
        fill: "white"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_7688_19748" }, [
        _createElementVNode("rect", {
          width: "22",
          height: "22",
          fill: "white",
          transform: "translate(0 0.513672)"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }